/** Normalize for API lookup (uppercase, no spaces/dashes/hash). */
export function normalizeOrderNumberInput(raw) {
  return String(raw || "")
    .trim()
    .replace(/^#/, "")
    .replace(/[\s-]+/g, "")
    .toUpperCase();
}

/** Human-friendly display: ABCD-EFGH-IJ (legacy numeric codes stay as-is). */
export function formatOrderNumberDisplay(code) {
  const c = normalizeOrderNumberInput(code);
  if (!c) return "";
  if (/^\d{1,6}$/.test(c)) return c;
  const parts = [];
  for (let i = 0; i < c.length; i += 4) {
    parts.push(c.slice(i, i + 4));
  }
  return parts.join("-");
}
